import React from "react";
import LogoPorto from "../../assets/images/logo-porto-header.webp";
import LogoOpenDays from "../../assets/images/logo-opendays-header.webp";
import LogoComPort from "../../assets/images/logo-com-port-header.webp";
import SocialIcons from "../SocialIcons/SocialIcons";
import "./header.css";
const Header = () => {
  return (
    <>
      <header id="header-215"className="header__container">
        <div className="header__content content__page">
          <div className="header__content-left">
          <a href="#header-215" target="_blank" rel="noreferrer">
              <img src={LogoOpenDays} alt="Porto de Aveiro 215 anos - Open Days" />
            </a>
            <a href="https://portodeaveiro.pt/" target="_blank" rel="noreferrer">
              <img src={LogoPorto} alt="Porto de Aveiro 215 anos - Open Days" />
            </a>
            <a href="https://www.comunidadeportuariadeaveiro.pt/inicio" target="_blank" rel="noreferrer">
              <img src={LogoComPort} alt="Porto de Aveiro 215 anos - Open Days" />
            </a>
          </div>
          <div className="header__content-right">
            <SocialIcons />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
